import { FC } from "react";
import { FormCheckbox } from "shared/ui";
import { LabeledInput } from "./LabeledInput";
import { Popover } from "./Popover";

import styles from "./PairsPicker.module.css";

interface Props {
  symbols: string[];
  value: string[];
  error?: string;
  disabled?: boolean;
  onChange: (symbols: string[]) => void;
}

const MAX_LISTED = 2;

const getSummary = (value: string[], isAll: boolean): string => {
  if (isAll) return "All pairs";
  if (!value.length) return "Select pairs";
  return value.length > MAX_LISTED ? `${value.length} pairs` : value.join(", ");
};

export const PairsPicker: FC<Props> = ({
  symbols,
  value,
  error,
  disabled,
  onChange,
}) => {
  const isAll = symbols.length > 0 && value.length === symbols.length;

  const toggle = (symbol: string) =>
    onChange(
      value.includes(symbol)
        ? value.filter((item) => item !== symbol)
        : [...value, symbol],
    );

  return (
    <LabeledInput label="Trading pairs">
      <Popover
        summary={getSummary(value, isAll)}
        error={error}
        disabled={disabled}
      >
        {() => (
          <div className={styles.list}>
            <FormCheckbox
              checked={isAll}
              onChange={() => onChange(isAll ? [] : symbols)}
            >
              All
            </FormCheckbox>
            {symbols.map((symbol) => (
              <FormCheckbox
                key={symbol}
                checked={value.includes(symbol)}
                onChange={() => toggle(symbol)}
              >
                {symbol}
              </FormCheckbox>
            ))}
          </div>
        )}
      </Popover>
    </LabeledInput>
  );
};
